export const IZILIFE_AUTH_API = import.meta.env.VITE_AUTH_API_URL || `https://api.izilifepay.com/api`;

export const MAIN_URL = "https://api.izicallcenter.com";
//export const MAIN_URL = "http://127.0.0.1:8000";

export const CMS_KAFINTECH_URL = import.meta.env.VITE_CMS_KAFINTECH_URL || `https://cms-api.kafintechgroup.com`;

export const MAIN_API_URL = `${MAIN_URL}/api`;
export const CMS_KAFINTECH_API_URL = `${CMS_KAFINTECH_URL}/api`;

export const API_BASE = MAIN_URL;

export const KAFINTECH_BENIN_API = `http://127.0.0.1:8000`;
